import React from 'react'
import styled from 'styled-components'
import {Check} from 'lucide-react'

interface CustomCheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  disabled?: boolean
  className?: string
}

const CheckboxContainer = styled.label<{$disabled: boolean}>`
  display: flex;
  align-items: center;
  gap: var(--space-2);
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  user-select: none;
`

const CheckboxInput = styled.input`
  display: none;
`

const CheckboxBox = styled.div<{$checked: boolean; $disabled: boolean}>`
  width: 16px;
  height: 16px;
  border: 2px solid ${(props) => (props.$checked ? 'var(--primary-700)' : 'var(--border-default)')};
  border-radius: var(--radius-sm);
  background: ${(props) => (props.$checked ? 'var(--primary-700)' : 'var(--bg-card)')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => (props.$disabled ? 'var(--border-default)' : 'var(--primary-700)')};
  }
`

const CheckIcon = styled(Check)<{$checked: boolean}>`
  width: 12px;
  height: 12px;
  color: var(--text-on-brand);
  opacity: ${(props) => (props.$checked ? 1 : 0)};
  transition: opacity 0.2s ease;
`

const CheckboxLabel = styled.span`
  font-size: var(--fs-body);
  font-weight: var(--fw-regular);
  color: var(--text-primary);
`

export const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
  className,
}) => {
  const handleChange = () => {
    if (!disabled) {
      onChange(!checked)
    }
  }

  return (
    <CheckboxContainer $disabled={disabled} className={className} onClick={handleChange}>
      <CheckboxInput
        type="checkbox"
        checked={checked}
        onChange={() => {}}
        onClick={(e) => e.stopPropagation()}
        disabled={disabled}
      />
      <CheckboxBox $checked={checked} $disabled={disabled}>
        <CheckIcon $checked={checked} />
      </CheckboxBox>
      {label && <CheckboxLabel>{label}</CheckboxLabel>}
    </CheckboxContainer>
  )
}

export default CustomCheckbox
